import React, { useEffect, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "./Slider.css"


export default function Slider() {
    const swiperWrappedRef = useRef(null);

    function adjustMargin() {
        const screenWidth = window.innerWidth;

        if (swiperWrappedRef.current) {
            swiperWrappedRef.current.style.marginLeft =
            screenWidth <= 520
            ? "0px"
            : screenWidth <= 650
            ? "-50px"
            : screenWidth <= 800
            ? "-100px"
            : "-150px";
        }
    }

    useEffect(() => {
        adjustMargin();
        window.addEventListener("resize", adjustMargin);
        return () => window.removeEventListener("resize", adjustMargin);
    }, []);
    return (
        <>
        <div id='booking' className='title_slider'>
            <div className='content_slider'>
                <h2>Book table</h2>
            </div>
            <div className="container_slider">
                <Swiper 
                    modules={[Pagination]}
                    z-index={-1}
                    grabCursor
                    initialSlide={0}
                    centeredSlides
                    slidesPerView="auto"
                    speed={800}
                    slideToClickedSlide
                    pagination={{clickable: true}}
                    breakpoints={{
                        320: { spaceBetween: 40 },
                        650: { spaceBetween: 30 },
                        1000: { spaceBetween: 20 }
                    }}
                    onSwiper={(Swiper) => {
                        swiperWrappedRef.current = Swiper.wrapperEl
                    }}
                >
                     <SwiperSlide>
                            <div className="img" />      
                            <div className="content">  
                                <a href="https://billetto.se/e/vocco-experience-biljetter-2028264?utm_source=organiser&utm_medium=share&utm_campaign=copy_link&utm_content=2">                  
                                <div className="footer_slider">
                                <div className="btn">
                                    <span className="label">Book table</span>
                                </div>
                                </div>
                                </a> 
                            </div>
                        </SwiperSlide>   
                        <SwiperSlide>
                            <div className="img2" />      
                            <div className="content">  
                                <a href='https://billetto.se/e/vocco-night-access-biljetter-2027863?utm_source=organiser&utm_medium=share&utm_campaign=copy_link&utm_content=2'>      
                                <div className="footer_slider">    
                                <div className="btn">
                                    <span className="label">Book Table</span>
                                </div>
                                </div>
                                </a> 
                            </div>
                        </SwiperSlide> 
                </Swiper>
            </div>
        </div>
        </>
    )
}